import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnChanges, Output, signal, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { firstValueFrom, Subscription } from 'rxjs';
import { ProjectVersion } from 'src/app/constants/project-version-constans';
import { CurrencyEnums } from 'src/app/enum/currency-enums';
import { PaperSizeEnums } from 'src/app/enum/paper-size-enums';
import { FormatDetailModel } from 'src/app/models/formats/format-detail.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { ChargeAccountDetailPrintModel } from 'src/app/models/invoicing/charge-account-detail-print.model';
import { ChargeAccountsPrintsModel } from 'src/app/models/invoicing/charge-accounts-prints.model';
import { EnterpriseModel } from 'src/app/models/management/enterprise.model';
import { FormatDetailService } from 'src/app/services/formats/format-detail.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { ValuesInLettersService } from 'src/app/services/global-services/values-in-letters.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ChargeAccountDetailService } from 'src/app/services/others/charge-account-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { PrintPageSizeService } from 'src/app/services/global-services/print-page-size.service';

interface GroupMetadata {
  valueWithDiscount: number;
  conceptName: string;
}

@Component({
  selector: 'app-print-charge-account',
  templateUrl: './print-charge-account.component.html',
  styleUrls: ['./print-charge-account.component.scss'],
  standalone: false
})
export class PrintChargeAccountComponent implements OnChanges {

  @Input() companyId: number | null = 0;
  @Input() editFormat: boolean = false;
  @Input() exportFormat: boolean = false;
  @Input() exporterChargeAccountDetailsPreview: any;
  @Input() chargeAccountModels: ChargeAccountsPrintsModel[] = [];
  @Input() chargeAccountTraffic: string = '';
  @Input() focusText: boolean = false;
  @Input() formatModel: FormatModel = new FormatModel();
  @Input() formatDetail: FormatDetailModel = new FormatDetailModel();
  @Output() emitFormatDetail = new EventEmitter<FormatDetailModel>();
  @Output() finishLoadingPrint = new EventEmitter<boolean>()
  @Output() finishLoadingPrintChargeAccount = new EventEmitter<boolean>();

  // Tabla Nueva
  groupDataMap = signal<Record<string, GroupMetadata>>({});
  columns: { field: string; header: string; }[] = [];
  idMap: { [key: string]: { id: string; type: string; showTotal: boolean; printFormat: string | null; } } = {
    'index': { id: 'index', type: 'number', showTotal: false, printFormat: null },
    'articleCodeName': { id: 'articulo', type: 'text', showTotal: false, printFormat: null },
    'inventoryUnitCode': { id: 'unidad-medida', type: 'text', showTotal: false, printFormat: null },
    'document': { id: 'documento', type: 'text', showTotal: false, printFormat: null },
    'dateInitial': { id: 'fecha-inicial', type: 'date', showTotal: false, printFormat: null },
    'dateFinal': { id: 'fecha-final', type: 'date', showTotal: false, printFormat: null },
    'quantity': { id: 'cantidad', type: 'decimal', showTotal: false, printFormat: null },
    'residue': { id: 'saldo', type: 'decimal', showTotal: false, printFormat: null },
    'totalTime': { id: 'dias', type: 'decimal', showTotal: false, printFormat: null },
    'discountRate': { id: 'porcentaje-descuento', type: 'decimal', showTotal: false, printFormat: null },
    'unitValueWithDiscount': { id: 'valor-unitario-cd', type: 'decimal', showTotal: false, printFormat: null },
    'discountValue': { id: 'valor-descuento', type: 'decimal', showTotal: false, printFormat: null },
    'totalValueWithDiscount': { id: 'valor-cd', type: 'decimal', showTotal: false, printFormat: null },
  };

  listFormatDetailUpdates: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  listRows: ChargeAccountDetailPrintModel[] = [];

  currencyLocal: number = CurrencyEnums.monedaLocal;
  electronicInvoice: boolean = false;
  enterpriseModel: EnterpriseModel | null = null;
  generalParametersId: Array<number> = new Array<number>();
  logoEnterprise: SafeUrl | null = null;
  logoFooterEnterprise: SafeUrl | null = null;
  paperSize: number = PaperSizeEnums.letter;
  paperSizeFormat: number = 0;
  signatureEnterprise: SafeUrl | null = null;
  totalRegDetail: number = 0;

  bottomPreview: number = 0;
  dateNow: Date = new Date();
  element: any;
  elementsBody: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  elementsLabel: Array<FormatDetailModel> = new Array<FormatDetailModel>();
  elementStyle: any;
  id = '';
  isShift = false;
  labelPrintFormatMap: Record<string, string | null> = {};
  leftPreview: number = 0;
  listObservers: Array<Subscription> = new Array<Subscription>();
  mouseDown: boolean = false;
  newFormatDetail: FormatDetailModel = new FormatDetailModel();
  rightPreview: number = 0;
  shiftX: number = 0;
  shiftY: number = 0;
  speed = 2;
  thArticulo: string = "";
  thCantidad: string = "";
  thDias: string = "";
  thDocumento: string = "";
  thFechaFinal: string = "";
  thFechaInicial: string = "";
  thIndex: string = "";
  thSaldo: string = "";
  thTarifaDescuento: string = "";
  thUnidadMedida: string = "";
  thValorCd: string = "";
  thValorDescuento: string = "";
  thValorUnitarioCd: string = "";
  topPreview: number = 0;
  userAuthenticated: string = '';
  version: string = ProjectVersion.projectVersion;
  private keydownListener!: (e: KeyboardEvent) => void;
  private mouseupListener!: () => void;
  private mousemoveListener!: (e: MouseEvent) => void;
  private keyupListener!: (e: KeyboardEvent) => void;

  constructor(
    private sanitizer: DomSanitizer,
    private enterpriseService: EnterpriseService,
    private formatDetailService: FormatDetailService,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private valuesInLettersService: ValuesInLettersService,
    private chargeAccountDetailService: ChargeAccountDetailService,
    private printPageSizeService: PrintPageSizeService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone) {
  }

  async ngOnInit() {
    await this.getUserAutheticated();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const exportFormat = changes["exportFormat"];
    const chargeAccountModels = changes["chargeAccountModels"];
    const formatDetail = changes["formatDetail"];
    const formatModel = changes["formatModel"];

    if (exportFormat && !exportFormat.firstChange) { this.updateRangeFormatDetail(); }
    if (formatModel && formatModel.firstChange) { this.formatModel = formatModel.currentValue; }

    if (chargeAccountModels && !chargeAccountModels.firstChange) {
      if (this.chargeAccountModels.length) {
        await Promise.all([
          this.getEnterpriseById(this.chargeAccountModels[0].enterpriseId),
        ]);
      }
    }

    if (formatDetail && !formatDetail.firstChange) { this.changeFormatDetail(); }

    const exporterChargeAccountDetailsPreview = changes["exporterChargeAccountDetailsPreview"];
    if (!exporterChargeAccountDetailsPreview || exporterChargeAccountDetailsPreview.firstChange) {
      return;
    }
    await this.exportChargeAccountDetails();
  }

  ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
    this.printPageSizeService.removePageSizeStyle();

    // Remover event listeners globales
    if (this.keydownListener) document.removeEventListener('keydown', this.keydownListener);
    if (this.mouseupListener) document.removeEventListener('mouseup', this.mouseupListener, true);
    if (this.mousemoveListener) document.removeEventListener('mousemove', this.mousemoveListener, true);
    if (this.keyupListener) document.removeEventListener('keyup', this.keyupListener);
  }

  ngAfterViewInit() {
    if (this.editFormat) {
      this.keydownListener = (e: KeyboardEvent) => {
        const target = e.target as HTMLElement;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.tagName === 'SELECT' ||
            target.isContentEditable)
        ) {
          return;
        }
        // 2. Si no hay ningún elemento seleccionado para mover, no bloquear
        if (!this.element) {
          return;
        }

        // Deshabilita desplazamiento del scroll con la tecla espacio y flechas
        if (["Space", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
          this.blockScrollArrows(e);
        }

        if (e.which == 16) this.isShift = true;
        //Mover element con flechas
        if (!this.isShift) {
          switch (e.key) {
            case 'ArrowLeft': { this.moveLeft(); break; }
            case 'ArrowRight': { this.moveRight(); break; }
            case 'ArrowUp': { this.moveUp(); break; }
            case 'ArrowDown': { this.moveDown(); break; }
          }
        }

        //Modificar element tamaño de objeto
        if (this.isShift) {
          switch (e.which) {
            case 37: { this.decreaseWidth(); break; }
            case 38: { this.decreaseHeight(); break; }
            case 39: { this.increaseWidth(); break; }
            case 40: { this.increaseHeight(); break; }
          }
        }
      };

      this.mouseupListener = () => {
        this.onMouseUp();
      };

      this.mousemoveListener = (e: MouseEvent) => {
        this.onMouseMove(e);
      };

      this.keyupListener = (e: KeyboardEvent) => {
        if (e.which == 16) this.isShift = false;
      };

      // Registrar los listeners en el document
      document.addEventListener('keydown', this.keydownListener);
      document.addEventListener('mouseup', this.mouseupListener, true);
      document.addEventListener('mousemove', this.mousemoveListener, true);
      document.addEventListener('keyup', this.keyupListener);
    }
  }

  blockScrollArrows(e: any) {
    if (!this.focusText) {
      e.preventDefault();
    }
  }

  buildLabelPrintFormatMap(): void {
    this.labelPrintFormatMap = (this.elementsLabel || []).reduce((acc, item) => {
      acc[item.name] = item.printFormat ?? null;
      return acc;
    }, {} as Record<string, string | null>);
  }

  changeAlignment(alignment: string) {
    this.element.style.textAlign = alignment;
  }

  changeBold(bold: string) {
    this.element.style.fontWeight = bold;
  }

  changeBorder(border: string) {
    switch (border) {
      case 'noborder': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        break;
      }
      case 'border': {
        this.element.style.border = '1px solid rgb(0, 0, 0)';
        break;
      }
      case 'underline': {
        this.element.style.border = '0px none rgb(0, 0, 0)';
        this.element.style.borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }
  }

  changeFormatDetail() {
    if (this.chargeAccountModels.length === 0) return;
    const formatDetailId = this.formatDetail.formatDetailId;
    if (formatDetailId == 0) return;

    const isBody = this.formatDetail.band === 'body';
    const isLabel = this.formatDetail.type === 'label';

    if (isBody) {
      const element = this.elementsBody.find(x => x.formatDetailId === formatDetailId);
      if (!element) return;

      element.alignment = this.formatDetail.alignment;
      element.fontSize = this.formatDetail.fontSize;
      element.printFormat = this.formatDetail.printFormat;

      if (isLabel) {
        element.visible = this.formatDetail.visible;
        element.width = this.formatDetail.width;
        element.text = this.formatDetail.text;

        if (!this.formatDetail.visible) {
          this.columns = this.columns.filter(x => x.field !== element.description);
        } else {
          this.updateElementStyle(this.formatDetail.name, this.chargeAccountModels[0].invoiceId);
          this.changeAlignment(this.formatDetail.alignment);
        }
      } else {
        element.bold = this.formatDetail.bold;
        this.chargeAccountModels[0].chargeAccountDetails.forEach(detail => {
          if (detail.invoiceDetailId) {
            this.updateElementStyle(this.formatDetail.name, detail.invoiceDetailId);
            this.changeAlignment(this.formatDetail.alignment);
            this.changeBold(this.formatDetail.bold);
          }
        });
      }
      const fieldName = element.description;
      if (fieldName && this.idMap[fieldName]) {
        this.idMap[fieldName].printFormat = element.printFormat;
      }
    } else {
      if (this.formatDetail.name.includes('foot-group')) {
        this.groupingClasses(this.formatDetail);
      } else {
        this.updateElementStyle(this.formatDetail.name, this.chargeAccountModels[0].invoiceId);

        if (!this.formatDetail.visible) {
          this.element.setAttribute('hidden', '');
        } else {
          this.applyFormatStyles(this.element);
          this.updateLabelText(formatDetailId, this.formatDetail.text!);
          this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId !== formatDetailId);
          this.listFormatDetailUpdates.push(this.formatDetail);
        }
      }
      const labelElement = this.elementsLabel.find(x => x.name === this.formatDetail.name);
      if (labelElement) {
        labelElement.printFormat = this.formatDetail.printFormat;
        this.elementsLabel = [...this.elementsLabel];
        this.buildLabelPrintFormatMap();
      }
    }

  }

  private updateElementStyle(name: string, id: string | number) {
    this.element = document.getElementById(`${name}-${id}`);
    if (!this.element) return;

    this.element.style.fontSize = `${this.formatDetail.fontSize}px`;
  }

  private applyFormatStyles(element: HTMLElement) {
    element.style.fontSize = `${this.formatDetail.fontSize}px`;
    this.changeAlignment(this.formatDetail.alignment);
    this.changeBold(this.formatDetail.bold);
    this.changeBorder(this.formatDetail.border);

    if (!this.formatDetail.name.includes('foot-')) {
      element.style.position = 'absolute';
      element.style.left = `${this.formatDetail.left}%`;
      element.style.top = `${this.formatDetail.top}%`;
    }

    element.style.height = `${this.formatDetail.height}px`;
    element.style.width = `${this.formatDetail.width}px`;
  }

  private updateLabelText(formatDetailId: number, text: string) {
    const labelElement = this.elementsLabel.find(x => x.formatDetailId === formatDetailId);
    if (labelElement) {
      labelElement.text = text;
    }
  }

  async chargeFormat(formatModel: FormatModel): Promise<boolean> {
    return new Promise((resolved) => {
      this.formatModel = formatModel;
      this.printPageSizeService.setPageSizeStyle(formatModel.paperSizeId);

      // Extraer etiquetas y cuerpo UNA SOLA VEZ
      this.extractFormatDetails(formatModel);
      this.ngZone.runOutsideAngular(async () => {

        // Dar tiempo al navegador para que pinte el DOM inicial
        setTimeout(async () => {
          for (let i = 0; i < this.chargeAccountModels.length; i++) {
            const chargeAccount = this.chargeAccountModels[i];

            // buildDisplayedColumns DEBE correr dentro de Angular Zone
            // para que p-table detecte el cambio en this.columns y renderice sus celdas
            await new Promise<void>(r => {
              this.ngZone.run(() => {
                this.buildDisplayedColumns();
                this.paperSizeFormat = formatModel.paperSizeId;
                this.cdr.detectChanges(); // Forzar renderizado de p-table
                r();
              });
            });

            // Esperar a que el navegador pinte las celdas recién creadas
            await new Promise(r => setTimeout(r, 0));

            this.applyHeaderFooterHeights(chargeAccount.invoiceId, formatModel);
            await this.applyFormatDetails(formatModel.formatDetails, chargeAccount);

            await this.applyColumnStyles(chargeAccount);
            this.applyParagraphStyles(chargeAccount);

            // Ceder el hilo al navegador cada 2 iteraciones para evitar congelamiento
            if (i % 2 === 0) {
              await new Promise(r => setTimeout(r, 0));
            }
          }
          this.ngZone.run(() => {
            this.cdr.markForCheck();
            resolved(true);
          });
        }, 100);
      });
    });
  }

  private applyHeaderFooterHeights(invoiceId: number, formatModel: FormatModel) {
    const head = document.getElementById(`head-${invoiceId}`);
    const foot = document.getElementById(`foot-${invoiceId}`);
    head!.style.height = `${formatModel.head}px`;
    foot!.style.height = `${formatModel.foot}px`;
    this.paperSizeFormat = formatModel.paperSizeId
  }

  private extractFormatDetails(formatModel: FormatModel) {
    this.elementsLabel = formatModel.formatDetails.filter(x => x.type === 'label');
    this.buildLabelPrintFormatMap();
    this.elementsBody = formatModel.formatDetails
      .filter(x => x.band === 'body' && x.visible)
      .sort((a, b) => a.orderTable - b.orderTable);
  }

  private buildDisplayedColumns() {
    this.columns = [];
    this.elementsBody.filter(x => x.type === 'label').forEach(element => {
      this.columns.push({ field: element.description!, header: element.text! });
      this.idMap[element.description!].printFormat = element.printFormat ?? null;
    });
  }

  private async applyFormatDetails(elements: FormatDetailModel[], invoice: ChargeAccountsPrintsModel) {
    for (const element of elements) {
      if (element.band === 'body') continue;

      if (element.name.includes('foot-group')) {
        setTimeout(() => { this.groupingClasses(element); }, 0);
      } else {
        this.element = document.getElementById(`${element.name}-${invoice.invoiceId}`);
        if (this.element) {
          this.applyElementStyles(element);
        }
      }
    }
  }

  private applyElementStyles(element: FormatDetailModel) {
    if (!element.visible) {
      this.element!.setAttribute('hidden', '');
      return;
    }

    const style = this.element!.style;
    style.fontSize = `${element.fontSize}px`;
    this.changeAlignment(element.alignment);
    this.changeBold(element.bold);
    this.changeBorder(element.border);

    if (element.name.includes('foot-')) {
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    } else {
      style.backgroundColor = 'transparent';
      style.position = 'absolute';
      style.left = `${element.left}%`;
      style.top = `${element.top}%`;
      style.height = `${element.height}px`;
      style.width = `${element.width}px`;
    }
  }

  private applyParagraphStyles(invoice: ChargeAccountsPrintsModel) {
    this.elementsBody
      .filter(x => x.type === 'p')
      .forEach(element => {
        invoice.chargeAccountDetails.forEach(detail => {
          this.element = document.getElementById(`${element.name}-${detail.invoiceDetailId}`);
          if (this.element) {
            this.element.style.fontSize = `${element.fontSize}px`;
            this.changeAlignment(element.alignment);
            this.changeBold(element.bold);
          }
        });
      });
  }

  private async applyColumnStyles(invoice: ChargeAccountsPrintsModel) {
    for (const column of this.columns.map(x => x.field)) {
      const element = this.elementsBody.find(x => x.description === column);
      if (!element) continue;

      this.element = document.getElementById(`${element.name}-${invoice.invoiceId}`);
      if (this.element) {
        this.element.style.fontSize = `${element.fontSize}px`;
        this.element.style.width = `${element.width}%`;
        await this.changeAlignment(element.alignment);
      }
    }
  }

  clickTable(event: any) {
    // if (this.editFormat) {
    if (!this.editFormat) return;

    const element = document.getElementById(event.target.id);
    if (!element) return;

    const elementStyle = window.getComputedStyle(element);
    const name = event.target.id.substring(0, event.target.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    const bodyElement = this.elementsBody.find(x => x.name === name);

    if (!formatDetail || !bodyElement) return;

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.type = formatDetail.type;
    this.newFormatDetail.visible = bodyElement.visible;
    this.newFormatDetail.text = bodyElement.text;
    this.newFormatDetail.orderTable = bodyElement.orderTable;

    // Ancho
    if (formatDetail.type === 'label') {
      const rawWidth = element.style.width;
      const width = parseFloat(rawWidth.replace('%', '')) || 0;
      this.newFormatDetail.width = parseFloat(width.toFixed(4));
    } else {
      this.newFormatDetail.width = 0;
    }

    // Tamaño de fuente
    const fontSize = parseInt(elementStyle.getPropertyValue('font-size').replace('px', ''));
    this.newFormatDetail.fontSize = isNaN(fontSize) ? 0 : fontSize;

    // Negrita
    const fontWeight = elementStyle.getPropertyValue('font-weight');
    this.newFormatDetail.bold = fontWeight === '400' ? 'normal' : 'bold';

    // Alineación
    this.newFormatDetail.alignment = elementStyle.getPropertyValue('text-align');

    this.emitFormatDetail.emit(this.newFormatDetail);
  }

  private adjustElementSize(property: 'height' | 'width', delta: number) {
    if (this.focusText) return;

    const currentValue = this.elementStyle.getPropertyValue(property);
    const numericValue = parseFloat(currentValue.replace('px', ''));

    const newValue = numericValue + delta;
    this.element.style[property] = `${newValue}px`;

    this.onClick();
  }

  decreaseHeight() {  // disminuirAltura
    this.adjustElementSize('height', -this.speed);
  }

  decreaseWidth() { // disminuirAncho
    this.adjustElementSize('width', -this.speed);
  }

  onColumnReorder() {
    this.columns.forEach((col, index) => {
      this.elementsBody.find(x => x.description == col.field)!.orderTable = index;
    });
  }

  async getEnterpriseById(enterpriseId: number) {
    if (this.enterpriseModel == null) {
      this.enterpriseModel = await firstValueFrom(this.enterpriseService.getEnterpriseById(enterpriseId));
      this.electronicInvoice = this.enterpriseModel.swElectronicInvoice;
      const promises = [];
      if (this.enterpriseModel.logo && this.logoEnterprise == null) promises.push(this.getLogo(this.enterpriseModel));
      if (this.enterpriseModel.signature && this.signatureEnterprise == null) promises.push(this.getSignature(this.enterpriseModel));
      await Promise.all(promises);
    }
    await this.configureFormatByInvoice();
  }

  async configureFormatByInvoice() {
    try {
      const promises = this.chargeAccountModels.flatMap(chargeAccount => this.processChargeAccount(chargeAccount));

      await Promise.all(promises);
      await this.chargeFormat(this.formatModel);

      this.finishLoadingPrintChargeAccount.emit(true);
    } catch (error) {
      console.error("Error en la configuración de factura:", error);
    }
  }

  async exportChargeAccountDetails() {
    const details = this.chargeAccountModels?.[0]?.chargeAccountDetails;
    if (!details || details.length === 0) {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
      return;
    }
    try {
      const invoiceId = this.chargeAccountModels?.[0]?.invoiceId ?? 0;
      const blob = await firstValueFrom(this.chargeAccountDetailService.exportChargeAccountDetails(invoiceId));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'VistaPreviaCuentaDeCobroDetalles.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar los detalles de la cuenta de cobro.', error);
    }
  }

  private processChargeAccount(chargeAccount: ChargeAccountsPrintsModel): Promise<void>[] {
    const promises: Promise<void>[] = [];

    // 2. Transformación de datos básicos
    chargeAccount.totalValueInLetters = this.valuesInLettersService.convertNumberToLetters(chargeAccount.totalValue, false);
    this.totalRegDetail = chargeAccount.chargeAccountDetails.length;

    // 3. Ordenar y Re-indexar detalles por concepto
    chargeAccount.chargeAccountDetails
      .sort((a, b) => a.conceptInvoicingId - b.conceptInvoicingId)
      .forEach((detail, index) => (detail.index = index + 1));

    // 4. Procesar Grupos si aplica
    if (this.formatModel.group) {
      const conceptPromises = this.getGroupPromises(chargeAccount);
      promises.push(...conceptPromises);
    }

    return promises;
  }

  private getGroupPromises(chargeAccount: ChargeAccountsPrintsModel): Promise<void>[] {
    const uniqueConceptIds = [...new Set(chargeAccount.chargeAccountDetails.map(d => d.conceptInvoicingId))];
    const partialResult: Record<string, GroupMetadata> = {};

    const promises = uniqueConceptIds.map(async (conceptId) => {
      const groupItems = chargeAccount.chargeAccountDetails.filter(d => d.conceptInvoicingId === conceptId);
      const firstItem = groupItems[0];
      const totalValueGroup = groupItems.reduce((sum, item) => sum + (item.totalValueWithDiscount || 0), 0);

      partialResult[`${chargeAccount.invoiceId}_${conceptId}`] = {
        valueWithDiscount: totalValueGroup,
        conceptName: firstItem.codeNameConceptInvoicing
      };
    });

    Promise.all(promises).then(() => {
      this.groupDataMap.update(current => ({ ...current, ...partialResult }));
    });

    return promises;
  }

  getLabelPrintFormat(name: string): string | null {
    return this.elementsLabel.find(x => x.name === name)?.printFormat ?? null;
  }

  async getLogo(enterpriseModel: EnterpriseModel) {
    const blob = await firstValueFrom(this.enterpriseService.getLogo(enterpriseModel));
    if (blob)
      this.logoEnterprise = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
  }

  async getSignature(enterpriseModel: EnterpriseModel) {
    const blob = await firstValueFrom(this.enterpriseService.getSignature(enterpriseModel));
    if (blob)
      this.signatureEnterprise = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
  }

  async groupingClasses(element: FormatDetailModel) {
    const classMap: { [key: string]: string } = {
      "foot-group-concept": ".group-concept"
    };

    const selector = classMap[element.name];
    if (selector) {
      const classEdit = document.querySelectorAll(selector);
      await this.setGroupingStyles(element, classEdit);
    }
  }

  increaseHeight() {  // aumentarAltura
    this.adjustElementSize('height', this.speed);
  }

  increaseWidth() {  // aumentarAncho
    this.adjustElementSize('width', this.speed);
  }

  isGroup(index: any, item: any): boolean {
    return item.level;
  }

  private moveElement(direction: 'top' | 'left', delta: number, previewLimit: number, isVertical: boolean) {
    if (this.focusText || !this.elementStyle) return;

    const currentValue = this.elementStyle.getPropertyValue(direction);
    let position = parseFloat(currentValue.replace('px', ''));

    position += delta;

    const sizeProp = isVertical ? 'height' : 'width';
    const size = parseFloat(this.elementStyle.getPropertyValue(sizeProp).replace('px', ''));

    // Restringir dentro del contenedor
    if (position < 0) position = 0;
    if (position + size > previewLimit) position = previewLimit - size;

    const percentage = ((position / previewLimit) * 100).toFixed(4);
    this.element.style[direction] = `${percentage}%`;

    this.onClick();
  }

  moveDown() {
    this.moveElement('top', this.speed, this.bottomPreview, true);
  }

  moveLeft() {
    this.moveElement('left', -this.speed, this.rightPreview, false);
  }

  moveRight() {
    this.moveElement('left', this.speed, this.rightPreview, false);
  }

  moveUp() {
    this.moveElement('top', -this.speed, this.bottomPreview, true);
  }

  onClick() {
    //Validar edición de formato
    if (!this.editFormat) return;

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) return;

    this.newFormatDetail = new FormatDetailModel();
    this.newFormatDetail.name = name;
    this.newFormatDetail.formatDetailId = formatDetail.formatDetailId;
    this.newFormatDetail.formatId = this.formatModel.formatId;
    this.newFormatDetail.band = formatDetail.band;
    this.newFormatDetail.description = formatDetail.description;
    this.newFormatDetail.text = formatDetail.text;
    this.newFormatDetail.visible = true;
    this.newFormatDetail.printFormat = formatDetail.printFormat;

    this.newFormatDetail.fontSize = this.getStylePxValue('font-size');
    this.newFormatDetail.bold = this.elementStyle.getPropertyValue('font-weight') === '400' ? 'normal' : 'bold';
    this.newFormatDetail.alignment = this.elementStyle.getPropertyValue('text-align');
    this.newFormatDetail.border = this.getBorderStyle();

    if (!name.includes('foot-')) {
      this.newFormatDetail.left = parseFloat(((this.getStylePxValue('left') / this.rightPreview) * 100).toFixed(4));
      this.newFormatDetail.top = parseFloat(((this.getStylePxValue('top') / this.bottomPreview) * 100).toFixed(4));
    }

    this.newFormatDetail.width = parseFloat(this.getStylePxValue('width').toFixed(4));
    this.newFormatDetail.height = parseFloat(this.getStylePxValue('height').toFixed(4));

    this.emitFormatDetail.emit(this.newFormatDetail);
    this.listFormatDetailUpdates = this.listFormatDetailUpdates.filter(x => x.formatDetailId != this.newFormatDetail.formatDetailId);
    this.listFormatDetailUpdates.push(this.newFormatDetail);

  }

  private getStylePxValue(property: string): number {
    const value = this.elementStyle.getPropertyValue(property);
    return parseFloat(value.replace('px', '')) || 0;
  }

  private getBorderStyle(): string {
    if (!this.elementStyle) return 'noborder';

    const sides = ['top', 'right', 'bottom', 'left'] as const;

    const hasBorder = (side: typeof sides[number]) => {
      const width = this.elementStyle.getPropertyValue(`border-${side}-width`);
      const style = this.elementStyle.getPropertyValue(`border-${side}-style`);
      return style !== 'none' && width !== '0px';
    };

    const borderStates = sides.map(side => hasBorder(side));
    const [top, right, bottom, left] = borderStates;

    if (top || right || left) {
      return 'border';
    } else if (bottom) {
      return 'underline';
    } else {
      return 'noborder';
    }
  }

  getUserAutheticated() {
    const load = this.userAuthenticatedService.userObservable.subscribe(async value => {
      this.userAuthenticated = value.userName;
      this.cdr.markForCheck();
    });
    this.listObservers.push(load);
  }

  onDragStart(event: any) {
    if (event?.target && ((event.target as HTMLElement).tagName === 'TH' || (event.target as HTMLElement).closest('th'))) {
      return true;
    }
    event?.preventDefault();
    return false;
  }

  //Mover objetos con el mouse
  onMouseDown(event: any) {
    if (!this.editFormat) return;

    const targetId = event.target.id;
    if (!targetId || targetId.startsWith('head-') || targetId.includes('preview-charge-account') || targetId.startsWith('th-') || targetId.startsWith('td-')
      || targetId.includes('container-totals') || targetId.includes(`foot-${this.chargeAccountModels[0].invoiceId}`) || targetId === '') return;

    if (this.element) this.element.style.backgroundColor = 'transparent';

    this.mouseDown = true;
    this.id = targetId;
    this.element = document.getElementById(this.id);
    if (!this.element) return;

    this.elementStyle = window.getComputedStyle(this.element);
    this.element.style.backgroundColor = '#0d6efd6e';

    const name = this.id.substring(0, this.id.lastIndexOf('-'));
    const formatDetail = this.formatModel.formatDetails.find(x => x.name === name);
    if (!formatDetail) return;

    const relativeElement = document.getElementById(`${formatDetail.band}-${this.chargeAccountModels[0].invoiceId}`);
    if (!relativeElement) return;

    const relativeStyle = window.getComputedStyle(relativeElement);

    this.leftPreview = Math.round(relativeElement.offsetLeft - relativeElement.scrollLeft);
    this.topPreview = Math.round(relativeElement.offsetTop - relativeElement.scrollTop);
    this.rightPreview = parseInt(relativeStyle.width.replace('px', ''));
    this.bottomPreview = parseInt(relativeStyle.height.replace('px', ''));

    if (!this.id.includes('foot-')) {
      this.element.style.cursor = 'move';

      const leftPX = event.pageX - this.leftPreview;
      const topPX = event.pageY - this.topPreview;

      this.shiftX = leftPX - this.getStylePx('left');
      this.shiftY = topPX - this.getStylePx('top');
    }

    this.onClick();
  }

  onMouseMove(event: any) {
    if (!this.mouseDown || this.id.includes('foot-')) return;

    this.element.style.position = 'absolute';

    const leftPx = Math.max(0, event.pageX - this.leftPreview - this.shiftX);
    const widthPx = this.getStylePx('width');
    const finalLeft = Math.min(leftPx, this.rightPreview - widthPx);

    const topPx = Math.max(0, event.pageY - this.topPreview - this.shiftY);
    const heightPx = this.getStylePx('height');
    const finalTop = Math.min(topPx, this.bottomPreview - heightPx);

    this.updateElementPosition(finalLeft, finalTop);
    this.onClick();
  }

  private getStylePx(property: string): number {
    return parseFloat(this.elementStyle.getPropertyValue(property).replace('px', '')) || 0;
  }

  private updateElementPosition(leftPx: number, topPx: number) {
    const leftPercentage = ((leftPx / this.rightPreview) * 100).toFixed(4);
    const topPercentage = ((topPx / this.bottomPreview) * 100).toFixed(4);

    this.element.style.left = `${leftPercentage}%`;
    this.element.style.top = `${topPercentage}%`;
  }
  onMouseUp() {
    this.mouseDown = false;
  }

  setGroupingStyles(element: FormatDetailModel, classEdit: any) {
    let border: string, borderBottom: string

    switch (element.border) {
      case 'noborder': {
        border = '0px none rgb(0, 0, 0)';
        borderBottom = '';
        break;
      }
      case 'border': {
        border = '1px solid rgb(0, 0, 0)';
        borderBottom = '';
        break;
      }
      case 'underline': {
        border = '0px none rgb(0, 0, 0)';
        borderBottom = '1px solid rgb(0, 0, 0)';
        break;
      }
    }

    classEdit.forEach((el: HTMLElement) => {
      el.style.fontSize = `${element.fontSize}px`;
      el.style.textAlign = element.alignment;
      el.style.fontWeight = element.bold;
      el.style.border = border;
      el.style.borderBottom = borderBottom;
      el.style.height = `${element.height}px`;
      el.style.width = `${element.width}px`;
    });
  }

  trackByChargeAccountId(index: number, item: ChargeAccountsPrintsModel): number {
    return item.invoiceId;
  }

  trackByColumnField(index: number, item: { field: string; header: string }): string {
    return item.field;
  }

  async updateRangeFormatDetail() {
    this.elementsBody.forEach(element => {
      this.listFormatDetailUpdates.push(element);
    });

    const response = await firstValueFrom(this.formatDetailService.updateRangeFormatDetail(this.listFormatDetailUpdates));
    this.chargeFormat(response);
  }
}
